import platformApi from './platformApi';

const tenantService = {
  async listar() {
    const { data } = await platformApi.get('/tenants');
    return data;
  },

  async obtener(id) {
    const { data } = await platformApi.get(`/tenants/${id}`);
    return data;
  },

  async crear(payload) {
    const { data } = await platformApi.post('/tenants', payload);
    return data;
  },

  async actualizar(id, payload) {
    const { data } = await platformApi.put(`/tenants/${id}`, payload);
    return data;
  },

  async suspender(id) {
    const { data } = await platformApi.post(`/tenants/${id}/suspend`);
    return data;
  },

  async activar(id) {
    const { data } = await platformApi.post(`/tenants/${id}/activate`);
    return data;
  },

  async eliminar(id) {
    const { data } = await platformApi.delete(`/tenants/${id}`);
    return data;
  },

  async listarPlanes() {
    const { data } = await platformApi.get('/plans');
    return data;
  },
};

export default tenantService;
